import { newsItems } from "@/mocks/gossip";

export default function DenySection() {
  const denies = newsItems.filter((n) => n.cat === "deny").slice(0, 3);
  const cols = [
    {
      icon: "ri-shield-check-line",
      title: "我们只做一件事",
      desc: "把每一句“据传”核到可溯源，把每一次反转讲出完整链条。拒绝情绪化带节奏，只呈现可验证的事实。",
      color: "text-secondary-600",
      bg: "bg-secondary-100",
    },
    {
      icon: "ri-focus-3-line",
      title: "三层信息核查",
      desc: "先确认消息源、再比对多方说法、最后核对发布方是否有权限发布。三层都过，才标注为“已核实”。",
      color: "text-accent-700",
      bg: "bg-accent-100",
    },
    {
      icon: "ri-list-check-2",
      title: "完整复盘呈现",
      desc: "不删旧稿、不打补丁。旧消息与最新进展并列展示，让读者看清事件如何一步步演变，避免断章取义。",
      color: "text-primary-600",
      bg: "bg-primary-100",
    },
  ];

  return (
    <section id="deny" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-6 rounded-2xl border border-secondary-200 bg-secondary-100/70 p-6 md:grid-cols-3 md:p-8">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-500 px-3 py-1 text-xs font-bold text-background-50">
              <i className="ri-check-double-line"></i>
              辟谣 · 澄清专区
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
              谣言止于核实
              <br className="hidden md:block" />
              我们不“造”，只负责“看穿”
            </h2>
          </div>

          <div className="flex flex-col justify-center gap-2.5 md:col-span-2">
            {denies.map((d) => (
              <div
                key={d.id}
                className="flex items-center gap-3 rounded-lg border border-secondary-200 bg-background-50/80 px-4 py-3"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                  <i className="ri-check-line"></i>
                </span>
                <div className="min-w-0 flex-1">
                  <div className="truncate text-sm font-semibold text-foreground-950">{d.title}</div>
                  <div className="text-xs text-foreground-500">已核实 · {d.tag}</div>
                </div>
                <span className="hidden shrink-0 items-center gap-1 text-xs font-semibold text-secondary-700 sm:inline-flex">
                  <i className="ri-eye-line"></i>
                  {d.read}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-3">
          {cols.map((c) => (
            <div key={c.title} className="flex gap-4 rounded-xl border border-background-200 bg-background-50 p-5">
              <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${c.bg}`}>
                <i className={`${c.icon} ${c.color} text-2xl`}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{c.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}